import { gsap } from 'gsap';

const op = () => {
    // GSAPタイムラインを作成
    const tl = gsap.timeline();
    const opElement = document.querySelector('.js-op');
    const opAnime = document.querySelector('.js-opAnime');
    // タイムラインに追加
    tl.set(opAnime,{
        opacity: '1',
      })
      .to(opElement, {
        filter: 'brightness(1.25)',
        duration: .8,
      } , '+=.3')
      .to(opElement, {
        opacity: 0,
        yPercent: 0,
        duration: 0.6,
      })
      .to(opElement, {
        display: "none",
      })
      ;

  };

const init = () => {
  const hasPlayed = sessionStorage.getItem('opAnimationPlayed');
  const opElement = document.querySelector('.js-op');

  // if (!hasPlayed) {
    // 初回: アニメーション実行
    op();
    sessionStorage.setItem('opAnimationPlayed', 'true');
  // } else {
  //   // 2回目以降: フェードアウト
  //   if (opElement) {
  //     gsap.to(opElement, {
  //       opacity: 0,
  //       duration: 0.5,
  //       ease: 'power2.inOut',
  //       onComplete: () => {
  //         opElement.style.display = 'none';
  //       }
  //     });
  //   }
  // }
};export default init;